.root {
  display: flex;
  flex-direction: column;
  // Minimum height so empty days are still a usable drop target.
  min-height: 48px;
}

.root-is-empty {
  border: 1px dashed var(--color-border);
  border-radius: 8px;
  margin: 4px 0;
  padding: 12px;
}

.root-is-over {
  background: var(--color-secondary);
}

.empty-hint {
  color: var(--color-muted-fg);
  font-size: 13px;
  text-align: center;
}
